"use strict";

var React = require("react");
var ThemeProvider = require("react-jss").ThemeProvider;

// remove the JSS style tag generated on the server to avoid conflicts with the one added on the client
exports.onInitialClientRender = function () {
  // eslint-disable-next-line no-undef
  var ssStyles = window.document.getElementById("server-side-jss");
  ssStyles && ssStyles.parentNode.removeChild(ssStyles);
};

exports.wrapRootComponent = function (_ref, options) {
  var Root = _ref.Root;
  return function () {
    var theme = options.theme || {};
    return React.createElement(
      ThemeProvider,
      { theme: theme },
      React.createElement(Root, null)
    );
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-jss/gatsby-browser.js
// module id = 387
// module chunks = 231608221292675